const ROOT_PATH = '/inn';

export const InnPaths = {
  ROOT_PATH,
} as const;
